import apiClient from "./apiClient";

// Staff
export const createStaff = (data) => {
  return apiClient.post(`/admin/staffs`, data);
};

export const getAllStaffs = () => {
  return apiClient.get(`/admin/staffs`);
};

export const getStaffById = (id) => {
  return apiClient.get(`/admin/staffs/${id}`);
};

export const updateStaffPermission = (id, permissions = {}) => {
  return apiClient.put(`/admin/staffs/${id}`, { permissions });
};

export const updateStaffStatus = (id, isActive) => {
  return apiClient.patch(`/admin/staffs/${id}/status`, { isActive });
};

// Users
export const createUser = (formData) => {
  return apiClient.post(`/admin/users`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getUsers = () => {
  return apiClient.get(`/admin/users`);
};

export const getUserDetailsById = (userId) => {
  return apiClient.get(`/admin/users/${userId}`);
};

export const updateUser = (userId, formData) => {
  return apiClient.put(`/admin/users/${userId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getUserByAccountNumber = (accountNumber) => {
  return apiClient.get(`/admin/users/account/${accountNumber}`);
};

// Transactions
export const updateAmount = (accountNumber, data) => {
  return apiClient.post(`/admin/transactions/${accountNumber}`, data);
};

export const getTransactionsByUserAccountNumber = (accountNumber) => {
  return apiClient.get(`/admin/transactions/user/${accountNumber}`);
};

export const getTodaysTransactions = () => {
  return apiClient.get(`/admin/transactions/today`);
};

export const getAllTransactions = () => {
  return apiClient.get(`/admin/transactions`);
};

export const getStaffTransactions = (params = {}) => {
  return apiClient.get(`/admin/transactions/staff-wise`, { params });
};

export const getStaffTransactionsByEmail = (email, type = "all") => {
  return apiClient.get('/admin/transactions/staff-transactions', {
    params: {
      email,
      type, // "today" or "all"
    },
  });
};

// Contact
export const getAllQueries = () => {
  return apiClient.get(`/admin/queries`);
};

export const deleteQuery = (id) => {
  return apiClient.delete(`/admin/queries/${id}`);
};


// finance
// LOANS
export const createLoan = (data) => apiClient.post('/admin/loans', data);
export const getAllLoans = () => apiClient.get('/admin/loans');
export const getUserLoans = (userId) => apiClient.get(`/admin/loans/user/${userId}`);

// FDs
export const createFD = (data) => apiClient.post('/admin/fds', data);
export const getAllFDs = () => apiClient.get('/admin/fds');

// INSURANCE
export const createInsurance = (data) => apiClient.post('/admin/insurance', data);
export const getAllInsurance = () => apiClient.get('/admin/insurance');
